// Settings shell. Tabbed sub-routes live under /settings/*.
//
// First tab: Blacklist. Future tabs (Users, Email defaults, etc)
// register here. The shell is intentionally minimal — when the
// list grows past a handful of tabs we'll switch to a sidebar.

import { NavLink, Outlet } from 'react-router-dom';
import { Ban, Inbox, Mail, Radio, Users, type LucideIcon } from 'lucide-react';

interface Tab {
  to: string;
  label: string;
  icon: LucideIcon;
}

const TABS: Tab[] = [
  { to: '/settings/users', label: 'Users', icon: Users },
  { to: '/settings/welcome-email', label: 'Welcome Email', icon: Mail },
  { to: '/settings/email-providers', label: 'Email Providers', icon: Inbox },
  { to: '/settings/sources', label: 'Sources', icon: Radio },
  { to: '/settings/blacklist', label: 'Blacklist', icon: Ban },
];

export default function SettingsLayout() {
  return (
    <div className="h-full overflow-y-auto bg-slate-50">
      <div className="max-w-5xl mx-auto py-6 px-4 sm:py-10 sm:px-6">
        <header className="mb-6">
          <h1 className="font-display text-2xl sm:text-3xl text-slate-900">
            Settings
          </h1>
          <p className="text-sm text-slate-500 mt-1">
            Site-wide configuration that affects how Pulitzer and the
            public site behave.
          </p>
        </header>

        <div className="flex border-b border-slate-200 mb-6 gap-1 overflow-x-auto">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) =>
                `inline-flex items-center gap-1.5 px-3 py-2 text-sm border-b-2 -mb-px whitespace-nowrap ${
                  isActive
                    ? 'border-blue-700 text-blue-700 font-medium'
                    : 'border-transparent text-slate-600 hover:text-slate-900'
                }`
              }
            >
              <t.icon size={14} />
              {t.label}
            </NavLink>
          ))}
        </div>

        <Outlet />
      </div>
    </div>
  );
}
